import { GetInvoicesOutput, Transaction, GISStatus, InvoiceType, Invoice, TimeOption, SettingsContentTypes } from "../../../types/wps";

export const mockInvoicePDF: Invoice = {
    id: 'id',
    transactionID: 'transId',
    actionURL: 'url',
    name: 'PDF',
    type: InvoiceType.CFDIPDF,
}
export const mockInvoice: Invoice = {
    id: 'id',
    transactionID: 'transId',
    actionURL: 'url',
    name: 'XML',
    type: InvoiceType.CFDI,
}

var invoices = {
    receipt: [mockInvoicePDF],
    taxInvoice: [mockInvoice],
    paymentComplement: [mockInvoice, mockInvoicePDF]
}
export const mockTransaction1: Transaction = {
    name: 'channel1',
    date: 'Sep 10, 2018',
    price: '$5.99',
    token: 'token',
    orderId: 'orderId',
    docId: 'docId',
    gisStatus: GISStatus.REQUEST,
    ...invoices
}

export const mockTransaction2: Transaction = {
    name: 'channel2',
    date: 'Sep 15, 2018',
    price: '$7.99',
    token: 'token',
    orderId: 'orderId',
    docId: 'docId',
    gisStatus: GISStatus.READY,
    rfcErrorMessage: {
        string: "We have been unable to process your order due to the lack of an RFC entry on your account. Please visit {link|rfcLink}Amazon{end} to update your RFC. We are now unable to generate this invoice, please contact {link|contactUsLink}Customer Service{end} to obtain this invoice",
        attrs: {
            "rfcLink": {
                "href": "https://www.amazon.com.mx/gp/taxRegistration/manage"
            },
            "contactUsLink": {
                "href": "/contactus/ref=atv_set_invoices_contact_us"
            }
        }
    },
    ...invoices
}
export const mockTransaction3: Transaction = {
    name: 'channel2',
    date: 'Sep 15, 2018',
    price: '$4.99',
    token: 'token',
    orderId: 'orderId',
    docId: 'docId',
    gisStatus: GISStatus.PENDING,
    ...invoices
}

export const mockTransaction4: Transaction = {
    name: 'channel4',
    date: 'Aug 20, 2018',
    price: '$5.99',
    token: 'token',
    orderId: 'orderId',
    docId: 'docId',
    gisStatus: GISStatus.READY,
    ...invoices
}

export const mockTransaction5: Transaction = {
    ...mockTransaction4,
    gisStatus: GISStatus.FAILED
}

export const mockMonth1: TimeOption = {
    name: 'January',
    value: '1',
    selected: false
}

export const mockMonth2: TimeOption = {
    name: 'February',
    value: '2',
    selected: false
}

export const mockMonth3: TimeOption = {
    name: 'March',
    value: '3',
    selected: true
}

export const mockMonth4: TimeOption = {
    name: 'April',
    value: '4',
    selected: false
}

export const mockYear1: TimeOption = {
    name: '2018',
    value: '1',
    selected: false
}

export const mockYear2: TimeOption = {
    name: '2019',
    value: '2',
    selected: true
}

export const strings = {
    DV_WEB_SETTINGS_INVOICEHISTORY_HEADER: "Your Payment History",
    DV_WEB_SETTINGS_AMZ_INVOICEHISTORY_HEADER: "Your Amazon Payment History",
    DV_WEB_SETTINGS_CHANNELS_INVOICEHISTORY_HEADER: "Prime Video Channels Payment History",
    DV_WEB_SETTINGS_INVOICEHISTORY_VIEWINVOICE_LINK: "View Invoice",
    DV_WEB_SETTINGS_INVOICEHISTORY_TEXT: "Go to Amazon to view your payment history",
    DV_WEB_SETTINGS_INVOICEHISTORY_LINKTEXT: "View on Amazon",
    DV_WEB_SETTINGS_INVOICEHISTORY_HEADING_PLAN: "Plan",
    DV_WEB_SETTINGS_INVOICEHISTORY_HEADING_DATE: "Date",
    DV_WEB_SETTINGS_INVOICEHISTORY_HEADING_PRICE: "Price",
    DV_WEB_SETTINGS_INVOICEHISTORY_DOC_CLASS_PRIMEMONTHLY: "Prime Video Monthly",
    DV_WEB_SETTINGS_INVOICEHISTORY_VIEWREFUND_LINK: "View Refund",
    DV_WEB_SETTINGS_INVOICEHISTORY_INTERVAL_SIX_MONTHS: "Last 6 Months",
    DV_WEB_SETTINGS_INVOICEHISTORY_NOHISTORY_TEXT: "No invoices are available for the selected period.",
    DV_WEB_SETTINGS_INVOICEHISTORY_ITUNES_MESSAGE: "For complete information visit iTunes account settings",
    DV_WEB_SETTINGS_VIEW_ITUNES_BTN: "View in iTunes",
    DV_WEB_SETTINGS_INVOICEHISTORY_GOOGLE_MESSAGE: "To review your transactions, go to Google Play Store.",
    DV_WEB_SETTINGS_VIEW_GOOGLE_BTN: "View in Play Store",
    DV_WEB_MANAGE_SUBS_VIEW_ALL: "View all",
    DV_WEB_MANAGE_SUBS_SUBSCRIPTION: "Channel",
    DV_WEB_MANAGE_SUBS_ACTIONS: "Actions",
    DV_WEB_MANAGE_SUBS_SHOW_RECEIPTS: "Show Receipts",
    DV_WEB_SETTINGS_INVOICEHISTORY_REQUEST: "Request",
    DV_WEB_SETTINGS_INVOICEHISTORY_PENDING: "Pending",
    DV_WEB_SETTINGS_INVOICEHISTORY_REQUEST_DOC: "Request Document(s)",
    DV_WEB_SETTINGS_INVOICEHISTORY_XML: "(XML)",
    DV_WEB_SETTINGS_INVOICEHISTORY_PDF: "(PDF)",
    DV_WEB_SETTINGS_INVOICEHISTORY_XML_REFUND: "Refund (XML)",
    DV_WEB_SETTINGS_INVOICEHISTORY_PDF_REFUND: "Refund (PDF)",
    DV_WEB_SETTINGS_INVOICEHISTORY_INVOICE: "Invoice",
    DV_WEB_SETTINGS_INVOICEHISTORY_FAILED: "Failed"
}

export const mockGetInvoicesResponse: GetInvoicesOutput = {
    __type: SettingsContentTypes.GetInvoicesOutput,
    transactions: [mockTransaction1, mockTransaction2, mockTransaction3, mockTransaction4],
    hasRfcError: true,
    monthList: [mockMonth1, mockMonth2, mockMonth3, mockMonth4],
    yearList: [mockYear1, mockYear2],
    showInvoices: true,
    headers: ['Channels', 'Date', 'Price', 'Commercial Receipt', 'Tax Invoice', 'Payment Complement'],
    links: {
        show_receipt_action: 'link1',
        retail_url: 'retail'
    },
    strings,
    rfcMessage: {attrs: 
    {amazonLink: 
      {href: "url"}
    }, 
    string: "To request a tax invoice go to {link|amazonLink}amazon{end} and provide your RFC number."},
    iapMessage: {
        header: "Your Payment History",
        message: "To review your transactions, go to Google Play Store.",
        link: {
            text: "View in Play Store",
            href: "href"
        }
    }
};


